import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const ContainerWrapper = ({ container, children }) => {
    const { t } = useTranslation();
    const {
        isLoading,
        hasLoadingError, loadingErrorMessage,
        hasLoadingOneError, loadingOneErrorErrorMessage,
        hasDeleteError, deleteErrorMessage,
    } = useSelector(state => state[container]);

    return (
        <>
            {isLoading &&
                <span className="loadingMessage">
                    <i className="fa fa-spinner fa-spin" />&nbsp;
                    { t('common.loading') }
                </span>
            }

            {(hasLoadingError || hasLoadingOneError) &&
                <div
                    className="alert alert-danger"
                    dangerouslySetInnerHTML={{__html: loadingErrorMessage ?? loadingOneErrorErrorMessage}}
                />
            }

            {hasDeleteError &&
                <div
                    className="alert alert-danger"
                    dangerouslySetInnerHTML={{__html: deleteErrorMessage}} />
            }

            { children }
        </>
    );
}

export default ContainerWrapper;
